import { useEffect, useState } from "react"
import api from "../services/api"
import companyBackofficeIntegradaDeSettings from "../helpers/companyBackofficeIntegrada"

export default function useCompanyBackofficeIntegrada() {
  const [lIntegrada, setLIntegrada] = useState(false)
  const [lCarregando, setLCarregando] = useState(true)

  useEffect(() => {
    let lAtivo = true

    async function carregar() {
      try {
        const { data } = await api.get("/settings")
        if (lAtivo) {
          setLIntegrada(companyBackofficeIntegradaDeSettings(data))
        }
      } catch (oErro) {
        if (lAtivo) {
          setLIntegrada(false)
        }
      } finally {
        if (lAtivo) {
          setLCarregando(false)
        }
      }
    }

    carregar()

    return () => {
      lAtivo = false
    }
  }, [])

  return { lIntegrada, lCarregando }
}
